<template>
  <div>
    <collegeBanner></collegeBanner>
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-4">
          <CollegeSideNavLayout></CollegeSideNavLayout>
        </div>
        <div class="col-md-9 col-sm-8">
          <div class="row">
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getPreferences['show_jobs']">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-briefcase"></i>
                  </div>
                  <div class="db-stat-count">{{ approved_jobs }} <span>Jobs</span></div>
                  <div class="db-stat-heading text-capitalize" v-if="pending_jobs != 0">
                    <router-link to="/dashboard/view-requested?type=jobs" class="text-red">Pending
                      Jobs: {{ pending_jobs }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getPreferences['show_internships']">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-briefcase"></i>
                  </div>
                  <div class="db-stat-count">{{ approved_internships }} <span>Internships</span></div>
                  <div class="db-stat-heading text-capitalize" v-if="pending_internships != 0">
                    <router-link to="/dashboard/view-requested?type=internships" class="text-red">
                      Pending Internships: {{ pending_internships }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-users"></i>
                  </div>
                  <div class="db-stat-count">{{ approved_candidates }} <span>Students</span></div>
                  <div class="db-stat-heading text-capitalize" v-if="pending_candidates != 0">
                    <router-link to="/dashboard/manage-candidates" class="text-red">Pending
                      Students: {{ pending_candidates }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-users"></i>
                  </div>
                  <div class="db-stat-count">2 <span>Teachers</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-puzzle-piece"></i>
                  </div>
                  <div class="db-stat-count">15 <span>Tests Conducted Lifetime</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-puzzle-piece"></i>
                  </div>
                  <div class="db-stat-count">7 <span>Tests Conducted This Week</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-allergies"></i>
                  </div>
                  <div class="db-stat-count">4 <span>Average Score</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="fas fa-user-alt-slash"></i>
                  </div>
                  <div class="db-stat-count">3 <span>Absentees</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6" v-if="this.$store.getters.getUser['business_activity'] != 'School'">
              <div class="db-stat-box">
                <div class="stat-details">
                  <div class="db-stat-icon">
                    <i class="far fa-building"></i>
                  </div>
                  <div class="db-stat-count">{{ total_companies }} <span>Companies</span></div>
                  <!--                                    <div class="db-stat-heading">Total Companies</div>-->
                </div>
              </div>
            </div>
            <!--                        <div class="col-md-4">-->
            <!--                            <div class="db-stat-box">-->
            <!--                                <div class="stat-details">-->
            <!--                                    <div class="db-stat-icon">-->
            <!--                                        <i class="fas fa-briefcase"></i>-->
            <!--                                    </div>-->
            <!--                                    <div class="db-stat-count">{{total_placement}} <span>Placements</span></div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </div>
          <!--                    <div class="row padd-top-50">-->
          <!--                        <div class="col-md-12">-->
          <!--                            <div class="dash-inner-box">-->
          <!--                                <div class="dashboard-heading">-->
          <!--                                    <div class="row">-->
          <!--                                        <div class="col-md-6">-->
          <!--                                            <h1>Competitions</h1>-->
          <!--                                        </div>-->
          <!--                                    </div>-->
          <!--                                </div>-->
          <!--                                <div class="row padd-top-10">-->
          <!--                                    <div class="col-md-12 mb-20">-->
          <!--                                        <div class="col-md-6">-->
          <!--                                            <router-link to="/edupreneur">-->
          <!--                                                <img src="images/ev.png" class="img-responsive"/>-->
          <!--                                            </router-link>-->
          <!--                                        </div>-->
          <!--                                        <div class="col-md-6">-->
          <!--                                            <router-link to="/redbull-basement-2020">-->
          <!--                                                <img src="images/redbull.png" class="img-responsive"/>-->
          <!--                                            </router-link>-->
          <!--                                        </div>-->
          <!--                                    </div>-->
          <!--                                </div>-->
          <!--                            </div>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <div class="row padd-top-50">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-3">
                      <h1>
                        My Students
                        <div class="db-stat-heading text-capitalize display-inline"
                             v-if="pending_candidates != 0">
                          <router-link to="/dashboard/manage-candidates" class="text-red">
                            Pending: {{ pending_candidates }}
                          </router-link>
                        </div>
                      </h1>
                    </div>
                    <div class="col-md-9">
                      <div class="view-all">
                        <router-link to="/dashboard/viewcandidates">View All</router-link>
                      </div>
                      <div class="view-all">
                        <router-link to="/dashboard/manage-candidates">Manage Students
                        </router-link>
                      </div>
                      <div class="view-all">
                        <a href="javascript:;" @click="showModal()">Invite Students</a>
                        <InviteCandidatesModal></InviteCandidatesModal>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12" v-if="candidates.length">
                    <div class="col-md-4" v-for="c in candidates">
                      <div class="new-cand-box">
                        <router-link
                            :to="{path: 'dashboard/viewcandidates?id=' + c.user_enc_id}">
                          <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-3">
                              <div class="new-cand-icon">
                                <img v-if="c.image != null || c.image == ''"
                                     v-bind:src="c.image"/>
                                <img v-else src="/images/user_avatar.png"/>
                              </div>
                            </div>
                            <div class="col-md-9 col-sm-9 col-xs-9">
                              <div class="new-cand-details">
                                <div class="new-cand-name">{{ c.first_name }}
                                  {{ c.last_name }}
                                </div>
                                <div class="new-cand-course">{{ c.name }}</div>
                                <div class="new-cand-course">
                                  {{ c.starting_year }}<span v-if="c.ending_year">-</span>{{ c.ending_year }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row position-bottom">
                            <div class="col-md-6 col-sm-6 col-xs-6">
                              <div class="new-cand-sem" v-if="c.semester == 1">1st
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 2">2nd
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 3">3rd
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 4">4th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 5">5th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 6">6th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 7">7th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 8">8th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 9">9th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semester == 10">10th
                                Semester
                              </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-6">
                              <div class="new-cand-apply">
                                <ul v-if="c.applied_companies.length">
                                  <li v-for="(av, index) in c.applied_companies.slice(0,3)">
                                    <div class="tooltip-main ssComapanies text-white">
                                      <img :src="av.logo">
                                      <span class="tooltiptext tooltip-bottom">{{ av.name }}</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="jobIocns stCards" v-if="c.loan_applied.length">
                            <div class="tooltip-main text-white">
                              <i class="fas fa-hand-holding-usd"></i>
                              <span class="tooltiptext tooltip-bottom">Applied Education Loan</span>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 text-center mb-20" v-else>
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">You have No Students Yet</h2>
                    <div class="view-all float-none">
                      <router-link to="/dashboard/manage-candidates">Manage Students</router-link>
                    </div>
                    <div class="view-all float-none">
                      <a href="javascript:;" @click="showModal()">Invite Students</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50" v-if="this.$store.getters.getUser['education_loan']">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-9">
                      <h1>
                        Loan Applicants
                      </h1>
                    </div>
                    <div class="col-md-3">
                      <div class="view-all">
                        <router-link to="/dashboard/loan-applicants">View All</router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12" v-if="loanApplicants.length">
                    <div class="col-md-4" v-for="c in loanApplicants">
                      <div class="new-cand-box">
                        <router-link
                            :to="{path: 'dashboard/loan-applicants?id=' + c.loan_app_enc_id}">
                          <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-3">
                              <div class="new-cand-icon">
                                <img v-if="c.image != null || c.image == ''"
                                     v-bind:src="c.image"/>
                                <img v-else src="/images/user_avatar.png"/>
                              </div>
                            </div>
                            <div class="col-md-9 col-sm-9 col-xs-9">
                              <div class="new-cand-details">
                                <div class="new-cand-name">{{ c.applicant_name }}</div>
                                <div class="new-cand-course">{{ c.course_name }}</div>
                                <div class="new-cand-course">{{ c.amount }}</div>
                              </div>
                            </div>
                          </div>
                          <div class="row position-bottom">
                            <div class="col-md-6 col-sm-6 col-xs-6">
                              <div class="new-cand-sem" v-if="c.semesters == 1">1st
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 2">2nd
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 3">3rd
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 4">4th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 5">5th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 6">6th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 7">7th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 8">8th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 9">9th
                                Semester
                              </div>
                              <div class="new-cand-sem" v-if="c.semesters == 10">10th
                                Semester
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 text-center mb-20" v-else>
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">No Students applied Yet</h2>
                    <div class="view-all float-none">
                      <a href="javascript:;" @click="showModal()">Invite Students</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50" v-if="this.$store.getters.getPreferences['show_teachers']">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-3">
                      <h1>My Teachers</h1>
                    </div>
                    <div class="col-md-9">
                      <!--                                            <div class="view-all">-->
                      <!--                                                <router-link to="/dashboard/viewcandidates">View All</router-link>-->
                      <!--                                            </div>-->
                      <div class="view-all">
                        <a href="javascript:;" @click="showTeachersModal()">Invite Teachers</a>
                        <InviteTeachersModal></InviteTeachersModal>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12" v-if="teachers.length">
                    <div class="col-md-4" v-for="c in teachers">
                      <div class="new-cand-box">
                        <a href="javascript:;">
                          <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-3">
                              <div class="new-cand-icon">
                                <img v-if="c.image != null || c.image == ''"
                                     v-bind:src="c.image"/>
                                <img v-else src="/images/user_avatar.png"/>
                              </div>
                            </div>
                            <div class="col-md-9 col-sm-9 col-xs-9">
                              <div class="new-cand-details">
                                <div class="new-cand-name">{{ c.first_name }}
                                  {{ c.last_name }}
                                </div>
                                <div class="new-cand-course">{{ c.role }}</div>
                                <div class="new-cand-course">{{ c.city_name }}</div>
                              </div>
                            </div>
                          </div>
                          <div class="row position-bottom">
                            <!--                                                        <div class="col-md-6 col-sm-6 col-xs-6">-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 1">1st Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 2">2nd Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 3">3rd Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 4">4th Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 5">5th Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 6">6th Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 7">7th Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 8">8th Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 9">9th Semester</div>-->
                            <!--                                                            <div class="new-cand-sem" v-if="c.semester == 10">10th Semester</div>-->
                            <!--                                                        </div>-->
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 text-center mb-20" v-else>
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">You have No Teachers Yet</h2>
                    <div class="view-all float-none">
                      <a href="javascript:;" @click="showTeachersModal()">Invite Teachers</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50"
               v-if="requested_org.length && this.$store.getters.getUser['business_activity'] != 'School'">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-6">
                      <h1>Requested Companies</h1>
                    </div>
                    <!--                                        <div class="col-md-6">-->
                    <!--                                            <div class="view-all">-->
                    <!--                                                <router-link to="/dashboard/viewcompanies">View All</router-link>-->
                    <!--                                            </div>-->
                    <!--                                        </div>-->
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12">
                    <div class="col-md-4 col-sm-6" v-for="rc in requested_org"
                         v-if="requested_org.length">
                      <router-link :to="{path: '/profile?slug=' + rc.org_slug}"
                                   data-aos="fade-zoom-in" class="cp-com-box">
                        <div class="cp-com-logo">
                          <router-link :to="{path: '/profile?slug=' + rc.org_slug}"><img
                              v-bind:src="rc.logo" alt=""></router-link>
                        </div>
                        <div class="jb-com-name">
                          <router-link :to="{path: '/profile?slug=' + rc.org_slug}" v-html="rc.organization_name">
                          </router-link>
                        </div>
                        <div class="cp-com-category">
                          {{ rc.business_activity }}
                        </div>
                        <div class="cp-com-opper large">
                          <p v-if="rc.jobs_count != 0">Jobs Available : <span>{{ rc.jobs_count }}</span>
                          </p>
                          <p v-if="rc.internships_count !=0">Internships Available :
                            <span>{{ rc.internships_count }}</span>
                          </p>
                        </div>
                        <div class="cp-view-btn">
                          <a href="javascript:;" @click.prevent="accept($event,'org')"
                             :data-key="rc.organization_enc_id">Accept</a>
                          <a href="javascript:;" @click.prevent="rejectWithReasons($event,'org')"
                             :data-key="rc.organization_enc_id" class="default">Reject</a>
                        </div>
                      </router-link>
                    </div>
                    <div class="col-md-12" v-else>
                      <h2>Currently there has no company applied.</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50"
               v-if="this.$store.getters.getPreferences['show_jobs'] && !this.$store.getters.getPreferences['jobs_approve']">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-6">
                      <h1>Requested Jobs</h1>
                    </div>
                    <div class="col-md-6">
                      <div class="view-all">
                        <router-link to="/dashboard/view-requested?type=jobs">View All
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12" v-if="requested_jobs.length">
                    <div class="col-md-4 col-sm-6" v-for="rj in requested_jobs">
                      <router-link :to="{path: '/detail?id=' + rj.slug}" data-aos="fade-zoom-in"
                                   class="cp-com-box">
                        <div class="cp-com-logo">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}"><img
                              v-bind:src="rj.logo" alt=""></router-link>
                        </div>
                        <div class="jb-com-name">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}" v-html="rj.name">
                          </router-link>
                        </div>
                        <div class="cp-com-category">
                          {{ rj.title }}
                        </div>
                        <span class="stamp is-nope" v-if="rj.is_closed">Recruitment Completed</span>
                        <div class="cp-com-opper">
                          Location : <span>{{ rj.location }}</span>
                        </div>
                        <div class="cp-com-opper">
                          Positions : <span>{{ rj.positions }}</span>
                        </div>
                        <div class="cp-com-opper">
                          <router-link :to="{path: '/detail?id=' + rj.slug}">View Job Detail
                          </router-link>
                        </div>
                        <div class="cp-view-btn cp-blank-actions" v-if="!rj.is_closed">
                          <a href="javascript:;" @click.prevent="accept($event,'job')"
                             :data-key="rj.application_enc_id"
                             :data-id="rj.org_enc_id">Accept</a>
                          <a href="javascript:;" @click.prevent="reject($event,'job')"
                             :data-key="rj.application_enc_id" class="default">Reject</a>
                        </div>
                        <div class="cp-blank-actions" v-else></div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" v-else>
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">No Requested Jobs Found</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50"
               v-if="this.$store.getters.getPreferences['show_internships'] && !this.$store.getters.getPreferences['internships_approve']">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-6">
                      <h1>Requested Internships</h1>
                    </div>
                    <div class="col-md-6">
                      <div class="view-all">
                        <router-link to="/dashboard/view-requested?type=internships">View All
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12" v-if="requested_internships.length">
                    <div class="col-md-4 col-sm-6" v-for="rj in requested_internships">
                      <router-link :to="{path: '/detail?id=' + rj.slug}" data-aos="fade-zoom-in"
                                   class="cp-com-box">
                        <div class="cp-com-logo">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}"><img
                              v-bind:src="rj.logo" alt=""></router-link>
                        </div>
                        <div class="jb-com-name">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}" v-html="rj.name">
                          </router-link>
                        </div>
                        <div class="cp-com-category">
                          {{ rj.title }}
                        </div>
                        <span class="stamp is-nope" v-if="rj.is_closed">Recruitment Completed</span>
                        <div class="cp-com-opper">
                          Location : <span>{{ rj.location }}</span>
                        </div>
                        <div class="cp-com-opper">
                          Positions : <span>{{ rj.positions }}</span>
                        </div>
                        <div class="cp-com-opper">
                          <router-link :to="{path: '/detail?id=' + rj.slug}">View Detail
                          </router-link>
                        </div>
                        <div class="cp-view-btn cp-blank-actions" v-if="!rj.is_closed">
                          <a href="javascript:;" @click.prevent="accept($event,'internship')"
                             :data-key="rj.application_enc_id"
                             :data-id="rj.org_enc_id">Accept</a>
                          <a href="javascript:;" @click.prevent="reject($event,'internship')"
                             :data-key="rj.application_enc_id" class="default">Reject</a>
                        </div>
                        <div class="cp-blank-actions" v-else></div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" v-else>
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">No Requested Internships Found</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50" v-if="this.$store.getters.getPreferences['show_jobs'] && emptyJobs.length">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-6">
                      <h1>List of Unapplied Jobs</h1>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12">
                    <div class="col-md-4 col-sm-6" v-for="rj in emptyJobs">
                      <router-link :to="{path: '/detail?id=' + rj.slug}" data-aos="fade-zoom-in" class="cp-com-box">
                        <div class="cp-com-logo">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}">
                            <img v-bind:src="rj.logo" alt="">
                          </router-link>
                        </div>
                        <div class="jb-com-name">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}" v-html="rj.name">
                          </router-link>
                        </div>
                        <div class="cp-com-category">
                          {{ rj.title }}
                        </div>
                        <span class="stamp is-nope" v-if="rj.is_closed">Recruitment Completed</span>
                        <div class="cp-com-opper">
                          Location : <span>{{ rj.location }}</span>
                        </div>
                        <div class="cp-com-opper">
                          Positions : <span>{{ rj.positions }}</span>
                        </div>
                        <div class="cp-view-btn">
                          <router-link :to="{path: '/detail?id=' + rj.slug}">
                            View Job Detail
                          </router-link>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50"
               v-if="this.$store.getters.getPreferences['show_internships'] && emptyInternships.length">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-6">
                      <h1>List of Unapplied Internships</h1>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12">
                    <div class="col-md-4 col-sm-6" v-for="rj in emptyInternships">
                      <router-link :to="{path: '/detail?id=' + rj.slug}" data-aos="fade-zoom-in" class="cp-com-box">
                        <div class="cp-com-logo">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}">
                            <img v-bind:src="rj.logo" alt="">
                          </router-link>
                        </div>
                        <div class="jb-com-name">
                          <router-link :to="{path: '/profile?slug=' + rj.org_slug}" v-html="rj.name">
                          </router-link>
                        </div>
                        <div class="cp-com-category">
                          {{ rj.title }}
                        </div>
                        <span class="stamp is-nope" v-if="rj.is_closed">Recruitment Completed</span>
                        <div class="cp-com-opper">
                          Location : <span>{{ rj.location }}</span>
                        </div>
                        <div class="cp-com-opper">
                          Positions : <span>{{ rj.positions }}</span>
                        </div>
                        <div class="cp-view-btn">
                          <router-link :to="{path: '/detail?id=' + rj.slug}">
                            View Internship Detail
                          </router-link>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50" v-if="this.$store.getters.getUser['business_activity'] != 'School'">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-6">
                      <h1>My Companies</h1>
                    </div>
                    <div class="col-md-6">
                      <div class="view-all">
                        <router-link to="/dashboard/viewcompanies">View All</router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12" v-if="companies.length">
                    <div class="col-md-4 col-sm-6" v-for="cm in companies">
                      <router-link :to="{path: '/profile?slug=' + cm.organizationEnc.org_slug}"
                                   data-aos="fade-zoom-in" class="cp-com-box">
                        <div class="cp-com-logo">
                          <router-link
                              :to="{path: '/profile?slug=' + cm.organizationEnc.org_slug}">
                            <img v-bind:src="cm.organizationEnc.logo" alt=""></router-link>
                        </div>
                        <div class="jb-com-name">
                          <router-link :to="{path: '/profile?slug=' + cm.organizationEnc.org_slug}"
                                       v-html="cm.organizationEnc.organization_name">
                          </router-link>
                        </div>
                        <div class="cp-com-category">
                          {{ cm.organizationEnc.business_activity }}
                        </div>
                        <div class="cp-com-opper">
                          Jobs Available : <span>{{ cm.organizationEnc.jobs_count }}</span>
                        </div>
                        <div class="cp-com-opper">
                          Internships Available : <span>{{ cm.organizationEnc.internships_count }}</span>
                        </div>
                        <div class="cp-view-btn">
                          <router-link
                              :to="{path: '/dashboard/all-jobs?slug=' + cm.organizationEnc.org_slug}">
                            View Jobs
                          </router-link>
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" v-else>
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">Currently there has no company approved yet.</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padd-top-50" v-if="this.$store.getters.getUser['business_activity'] === 'School'">
            <div class="col-md-12">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-3">
                      <h1>
                        Top Students
                      </h1>
                    </div>
                    <div class="col-md-9">

                    </div>
                  </div>
                </div>
                <div class="row padd-top-10">
                  <div class="col-md-12">
                    <div class="col-md-4">
                      <div class="new-cand-box">
                        <router-link
                            to="/dashboard/viewcandidates?id=R09YXEkaql0awkw65XYb7531Wdo82J"
                            class="">
                          <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-3">
                              <div class="new-cand-icon">
                                <img
                                    src="https://ui-avatars.com/api/?name=Ajay&amp;size=200&amp;rounded=false&amp;background=77a4dd&amp;color=ffffff">
                              </div>
                            </div>
                            <div class="col-md-9 col-sm-9 col-xs-9">
                              <div class="new-cand-details">
                                <div class="new-cand-name">Ajay Juneja
                                </div>
                                <div class="new-cand-course">IT</div>
                                <div class="new-cand-course">2020-2023
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="new-cand-box">
                        <router-link
                            to="/dashboard/viewcandidates?id=R09YXEkaql0awkw65XYb7531Wdo82J"
                            class="">
                          <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-3">
                              <div class="new-cand-icon">
                                <img
                                    src="https://ui-avatars.com/api/?name=Tarandeep&size=200&rounded=false&background=efc4fc&color=ffffff">
                              </div>
                            </div>
                            <div class="col-md-9 col-sm-9 col-xs-9">
                              <div class="new-cand-details">
                                <div class="new-cand-name">Tarandeep Singh
                                </div>
                                <div class="new-cand-course">+2</div>
                                <div class="new-cand-course">2020-2023
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="new-cand-box">
                        <router-link
                            to="/dashboard/viewcandidates?id=R09YXEkaql0awkw65XYb7531Wdo82J"
                            class="">
                          <div class="row">
                            <div class="col-md-3 col-sm-3 col-xs-3">
                              <div class="new-cand-icon">
                                <img
                                    src="https://ui-avatars.com/api/?name=Ravinder&size=200&rounded=false&background=efc4fc&color=ffffff">
                              </div>
                            </div>
                            <div class="col-md-9 col-sm-9 col-xs-9">
                              <div class="new-cand-details">
                                <div class="new-cand-name">Ravinder Singh
                                </div>
                                <div class="new-cand-course">+2</div>
                                <div class="new-cand-course">2020-2023
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="rejectReasonModal" class="modal" data-backdrop="static" data-keyboard="false">
      <div class="mecpopup-container">
        <div class="mecpopup-popup" role="dialog">
          <div class="mecpopup-olay"></div>
          <button class="mecpopup-close" title="Close" @click="modalClose">
            <svg width="16" height="16" viewBox="0 0 16 16">
              <g stroke="#777" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round">
                <path d="M4 12L12 4M4 4l8 8"></path>
              </g>
            </svg>
          </button>
          <div class="mecpopup-content-main">
            <div class="mecpopup-content">
              <div class="mecpopup-inner-content">
                <div class="mecpopup-column">
                  <div class="mecpopup-blocks-wrapper">
                    <div class="mecpopup-fields">
                      <div class="mecpopup-fields-inner">
                        <div class="mecpopup-block-text">
                          <div data-contents="true">
                            <div>
                                    <span
                                        style="font-weight: 700; font-size: 32px; font-family: Lato; color: rgb(0, 0, 0);">
                                        <span data-text="true">Select Reasons to Reject</span>
                                    </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mecpopup-fields">
                      <div class="row sort-flex">
                        <div class="col-sm-6 col-sm-offset-2">
                          <input type="text" id="inputReasons" name="inputReasons" class="form-control"
                                 placeholder="Enter any Reason"/>
                        </div>
                        <div class="col-sm-3">
                          <button type="button" class="main-button-primary" @click="addReason(0)"><i class="fa fa-plus"></i> Add Reason</button>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <ul class="ks-cboxtags">
                            <li v-for="rr in getInitReasons">
                              <input type="checkbox" :id="rr.rejection_reason_enc_id"
                                     :value="rr.rejection_reason_enc_id" name="rejectReasons"/>
                              <label :for="rr.rejection_reason_enc_id">{{ rr.reason }}</label>
                            </li>
                          </ul>
                          <div class="col-md-12">
                            <div class="form-group text-center">
                              <button type="submit" class="update-profile" @click="finalReject()">Submit</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollegeSideNavLayout from './../../components/CollegeSideNavLayout.vue'
import collegeBanner from './../../components/collegeBanner.vue'
import InviteCandidatesModal from './../../components/InviteCandidatesModal.vue'
import InviteTeachersModal from './../../components/InviteTeachersModal.vue'
import axios from 'axios';
import toastr from '../../../public/js/toastr.js';
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
  components: {
    CollegeSideNavLayout,
    collegeBanner,
    InviteCandidatesModal,
    InviteTeachersModal,
  },
  data() {
    return {
      total_placement: '',
      total_companies: '',
      approved_jobs: '',
      pending_jobs: '',
      approved_internships: '',
      pending_internships: '',
      approved_candidates: '',
      pending_candidates: '',
      candidates: '',
      teachers: [],
      companies: '',
      requested_org: [],
      requested_jobs: [],
      requested_internships: [],
      loanApplicants: [],
      emptyJobs: [],
      emptyInternships: [],
      getInitReasons: [],
      jobs_auto_approve: true,
      college_name: "",
      rejectedId: "",
    }
  },
  mounted() {
    var t = this;
    var url = this.$store.getters.getDomain;
    var clg_id = this.$store.getters.getCollegeId;

    axios.post(`${url}api/v2/college-index/counts`, '', {headers: requestHeaders()}).then(function (response) {
      document.getElementById("h-page-load").classList.add("hides");
      t.total_companies = response['data']['response']['data']['company_count'];
      t.jobs_auto_approve = response['data']['response']['data']['jobs_auto_approve'];
      t.approved_candidates = response['data']['response']['data']['approved_candidate_count'];
      t.pending_candidates = response['data']['response']['data']['pending_candidate_count'];
      t.approved_jobs = response['data']['response']['data']['approved_jobs'];
      t.pending_jobs = response['data']['response']['data']['pending_jobs'];
      t.approved_internships = response['data']['response']['data']['approved_internships'];
      t.pending_internships = response['data']['response']['data']['pending_internships'];
      t.total_placement = response['data']['response']['data']['placements_count'];
      t.candidates = response['data']['response']['data']['candidates'];
      t.companies = response['data']['response']['data']['companies'];
    }).catch(function (error) {
      alert('Unstable Internet Connection');
      location.reload();
    });
    if (this.$store.getters.getPreferences['show_jobs']) {
      this.getJobs();
    }
    if (this.$store.getters.getPreferences['show_internships']) {
      this.getInternships();
    }
    if (this.$store.getters.getUser['business_activity'] != 'School') {
      this.getCompanies();
    }
    if (this.$store.getters.getPreferences['show_teachers']) {
      this.getTeachers();
    }
    if (this.$store.getters.getUser['education_loan']) {
      this.getLoanApplicants();
    }
    this.getRejectReasons(0);
  },
  methods: {
    modalClose() {
      $('#rejectReasonModal').modal('hide');
    },
    addReason(type) {
      var t = this;
      var reason = document.getElementById('inputReasons').value;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/save-reason`, {reason: reason, reason_for: type}, {
        headers: requestHeaders()
      }).then(function (response) {
        if (response['data']['response']['status'] == 200) {
          t.getInitReasons.push(response['data']['response']['data']);
          toastr.success('Reason Added Successfully', 'Success');
          document.getElementById('inputReasons').value = "";
          setTimeout(function () {
            document.getElementById(response['data']['response']['data'].rejection_reason_enc_id).checked = true;
          }, 800)
        }
      })
    },
    finalReject(){
      var t = this;
      var url = this.$store.getters.getDomain;
      var data = 'Reject';

      var selectedReasons = [];
      var reasonsElem = document.getElementsByName('rejectReasons');
      for(var d =0;d<reasonsElem.length;d++){
        if(reasonsElem[d].checked){
          selectedReasons.push(reasonsElem[d].value);
        }
      }
      axios.post(`${url}api/v2/college-index/company-approve`, {
        organization_enc_id: t.rejectedId,
        action: data,
        reasons:selectedReasons
      }, {
        headers: requestHeaders()
      }).then(function (response) {
        if (response['data']['response']['status'] == 200) {
          toastr.success('Company Rejected', 'Success');
        }
        t.getCompanies();
        for(var d =0;d<reasonsElem.length;d++){
          if(reasonsElem[d].checked){
            reasonsElem[d].checked = false;
          }
        }
        $('#rejectReasonModal').modal('hide');
      })
    },
    accept: function (event, type) {
      var t = this;
      var element = event.currentTarget;
      var data_key = element.getAttribute('data-key');
      var url = this.$store.getters.getDomain;
      var data = 'Accept';

      if (type == "org") {
        axios.post(`${url}api/v2/college-index/company-approve`, {
          organization_enc_id: data_key,
          action: data
        }, {
          headers: requestHeaders()
        }).then(function (response) {
          if (response['data']['response']['status'] == 200) {
            toastr.success('Company added Successfully', 'Success');
          }
          t.getCompanies();
        })
      } else if (type == 'job' || type == 'internship') {
        var data_id = element.getAttribute('data-id');
        axios.post(`${url}api/v2/college-index/job-approve`, {
          application_enc_id: data_key,
          org_enc_id: data_id,
          action: data
        }, {
          headers: requestHeaders()
        }).then(function (response) {
          if (response['data']['response']['status'] == 200) {
            if (type == 'job') {
              t.getJobs();
              toastr.success('Job Approved Successfully', 'Success');
            } else {
              t.getInternships();
              toastr.success('Internship Approved Successfully', 'Success');
            }
          } else {
            toastr.error('An error occurred try again later.', 'Error');
          }
        })
      }
    },
    reject: function (event, type) {
      var t = this;
      var element = event.currentTarget
      var data_key = element.getAttribute('data-key');
      var url = this.$store.getters.getDomain;
      var data = 'Reject';

      if (type == "org") {
        axios.post(`${url}api/v2/college-index/company-approve`, {
          organization_enc_id: data_key,
          action: data
        }, {
          headers: requestHeaders()
        }).then(function (response) {
          if (response['data']['response']['status'] == 200) {
            toastr.success('Company Rejected', 'Success');
          }
          t.getCompanies();
        })
      } else if (type == 'job' || type == 'internship') {
        axios.post(`${url}api/v2/college-index/job-approve`, {application_enc_id: data_key, action: data}, {
          headers: requestHeaders()
        }).then(function (response) {
          if (response['data']['response']['status'] == 200) {
            if (type == 'job') {
              t.getJobs();
              toastr.success('Job Rejected Successfully', 'Success');
            } else {
              t.getInternships();
              toastr.success('Internship Rejected Successfully', 'Success');
            }
          } else {
            toastr.error('An error occurred try again later.', 'Error');
          }
        })
      }
    },
    rejectWithReasons: function (event, type) {
      var t = this;
      var element = event.currentTarget
      t.rejectedId = element.getAttribute('data-key');
      $('#rejectReasonModal').modal('show');
    },
    getTeachers() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/college-teachers`, "", {headers: requestHeaders()}).then(function (response) {
        if (response['data']['response']['status'] === 200) {
          t.teachers = response['data']['response']['data'];
        }
      });
    },
    getRejectReasons(type) {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/get-reasons`, {reason_for: 0}, {headers: requestHeaders()}).then(function (response) {
        if (response['data']['response']['status'] === 200) {
          t.getInitReasons = response['data']['response']['data'];
        }
      });
    },
    getJobs() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/jobs-selection`, {
        type: "Jobs",
        limit: 6
      }, {headers: requestHeaders()}).then(function (response) {
        t.getEmptyJobs();
        if (response['data']['response']['status'] === 200) {
          t.requested_jobs = response['data']['response']['jobs'];
        } else {
          t.requested_jobs = [];
        }
      });
    },
    showModal() {
      $('#inviteCandidateModal').modal('show');
    },
    showTeachersModal() {
      $('#inviteTeachersModal').modal('show');
    },
    getInternships() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/jobs-selection`, {
        type: "Internships",
        limit: 6
      }, {headers: requestHeaders()}).then(function (response) {
        t.getEmptyInternships();
        if (response['data']['response']['status'] === 200) {
          t.requested_internships = response['data']['response']['jobs'];
        } else {
          t.requested_internships = [];
        }
      });
    },
    getEmptyJobs() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/empty-jobs`, {
        type: "Jobs",
        limit: 6
      }, {headers: requestHeaders()}).then(function (response) {
        if (response['data']['response']['status'] === 200) {
          t.emptyJobs = response['data']['response']['data'];
        }
      });
    },
    getEmptyInternships() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/empty-jobs`, {
        type: "Internships",
        limit: 6
      }, {headers: requestHeaders()}).then(function (response) {
        if (response['data']['response']['status'] === 200) {
          t.emptyInternships = response['data']['response']['data'];
        }
      });
    },
    getCompanies() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/college-index/company-selection`, "", {headers: requestHeaders()}).then(function (response) {
        if (response['data']['response']['status'] === 200) {
          t.requested_org = response['data']['response']['data'];
        } else {
          t.requested_org = [];
        }
      });
    },
    getLoanApplicants() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/loans/college-student-loans`, {limit: 6}, {headers: requestHeaders()}).then(function (response) {
        if (response['data']['response']['data'].length) {
          t.loanApplicants = response['data']['response']['data'];
        }
      });
    },
  },
}
</script>

<style scoped>
.cp-com-opper {
  position: relative;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 32px;
}

.cp-com-opper.large {
  height: 50px;
}

.display-inline {
  display: inline;
}

.mecpopup-popup {
  max-width: 750px;
  width: 100%;
}

.mecpopup-content {
  padding: 30px 40px !important;
}

.row.sort-flex {
  justify-content: space-around;
}

ul.ks-cboxtags {
  list-style: none;
  padding: 20px;
}

ul.ks-cboxtags li {
  display: inline;
}

ul.ks-cboxtags li label {
  display: inline-block;
  background-color: rgba(255, 255, 255, .9);
  border: 2px solid rgba(139, 139, 139, .3);
  color: #adadad;
  border-radius: 25px;
  white-space: nowrap;
  margin: 5px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: all .2s;
}

ul.ks-cboxtags li label {
  padding: 8px 12px;
  cursor: pointer;
  line-height: normal;
}

ul.ks-cboxtags li label::before {
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 12px;
  padding: 2px 6px 2px 2px;
  content: "\f067";
  transition: transform .3s ease-in-out;
}

ul.ks-cboxtags li input[type="checkbox"]:checked + label::before {
  content: "\f00c";
  transform: rotate(-360deg);
  transition: transform .3s ease-in-out;
}

ul.ks-cboxtags li input[type="checkbox"]:checked + label {
  border: 2px solid #00a0e3;
  background-color: #00a0e3;
  color: #fff;
  transition: all .2s;
}

ul.ks-cboxtags li input[type="checkbox"] {
  display: absolute;
}

ul.ks-cboxtags li input[type="checkbox"] {
  position: absolute;
  opacity: 0;
}

ul.ks-cboxtags li input[type="checkbox"]:focus + label {
  border: 2px solid #00a0e3;
}

.main-button-primary {
  line-height: normal;
}
</style>